import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { UiRenderer, DialogComponent } from '@m27/common';

import { PlantingReportCriteriaDialogComponent } from '@reporting/pages/planting-report/criteria-dialog/dialog-planting-report-criteria.component';
import { ReportXmlResultDialogComponent } from '@reporting/dialogs/report-xml-result/dialog-report-xml-result.component';
import { VolunteerReportXmlResultDialogComponent } from '@reporting/dialogs/report-xml-result/dialog-volunteer-report-xml-result.component';
import { VolunteerReportCriteriaDialogComponent } from '@reporting/pages/volunteer-report/criteria-dialog/dialog-volunteer-report-criteria.component';
import { NotPlantedReportCriteriaDialogComponent } from '@reporting/pages/not-planted-report/criteria-dialog/dialog-not-planted-report-criteria.component';
import { FinalFieldTestReportCriteriaDialogComponent } from '@reporting/pages/final-field-test-report/criteria-dialog/dialog-final-field-test-report-criteria.component';
import { RegulatedRegCompReportCriteriaDialogComponent } from '@reporting/pages/regulated-regcomp-report/criteria-dialog/dialog-regulated-regcomp-report-criteria.component';
import { StewardedRegCompReportCriteriaDialogComponent } from '@reporting/pages/stewarded-regcomp-report/criteria-dialog/dialog-stewarded-regcomp-report-criteria.component';


@Component({
    selector: 'app-reporting-dialogs',
    templateUrl: './dialog.component.html'
})
export class ReportingDialogsComponent extends DialogComponent {

    @ViewChild(ReportXmlResultDialogComponent, { static: true }) public ReportXmlResult: ReportXmlResultDialogComponent;
    @ViewChild(PlantingReportCriteriaDialogComponent, { static: true }) public PlantingReportCriteria: PlantingReportCriteriaDialogComponent;
    @ViewChild(VolunteerReportXmlResultDialogComponent, { static: true }) public VolunteerReportXmlResult: VolunteerReportXmlResultDialogComponent;
    @ViewChild(VolunteerReportCriteriaDialogComponent, { static: true }) public VolunteerReportCriteria: VolunteerReportCriteriaDialogComponent;
    @ViewChild(NotPlantedReportCriteriaDialogComponent, { static: true }) public NotPlantedReportCriteria: NotPlantedReportCriteriaDialogComponent;
    @ViewChild(FinalFieldTestReportCriteriaDialogComponent, { static: true }) public FinalFieldTestReportCriteria: FinalFieldTestReportCriteriaDialogComponent;
    @ViewChild(RegulatedRegCompReportCriteriaDialogComponent, { static: true }) public RegulatedRegCompReportCriteria: RegulatedRegCompReportCriteriaDialogComponent;
    @ViewChild(StewardedRegCompReportCriteriaDialogComponent, { static: true }) public StewardedRegCompReportCriteria: StewardedRegCompReportCriteriaDialogComponent;

    constructor(ui: UiRenderer, router: Router, sanitizer: DomSanitizer) {
        super(ui, router, sanitizer);
    }

    initializeDialogs() {
        this.PlantingReportCriteria.initalize(this.ui, this, this.sanitizer);
        this.ReportXmlResult.initalize(this.ui, this, this.sanitizer);
        this.VolunteerReportXmlResult.initalize(this.ui, this, this.sanitizer);
        this.VolunteerReportCriteria.initalize(this.ui, this, this.sanitizer);
        this.NotPlantedReportCriteria.initalize(this.ui, this, this.sanitizer);
        this.FinalFieldTestReportCriteria.initalize(this.ui, this, this.sanitizer);
        this.RegulatedRegCompReportCriteria.initalize(this.ui, this, this.sanitizer);
        this.StewardedRegCompReportCriteria.initalize(this.ui, this, this.sanitizer);
    }
}

